import { templateParseToElement } from "../../logic/templateParse.js";
import { BaseWebComponent } from "../base-components/base-web-component.js";
export class FilterInputRangeComponent extends BaseWebComponent {
    static webComponentName: string = "filter-input-range";
    private _filterValueType: string = ''; // Default to number, can be overridden

    public get filterValueType(): string {
        return this._filterValueType;
    }
    public get inputs(): NodeListOf<HTMLInputElement> {
        return this.querySelectorAll('input') as NodeListOf<HTMLInputElement>;
    }
    get value(): [number | string | Date, number | string | Date] | null {
        const inputs = this.inputs;
        if (inputs.length === 2 && inputs[0].value && inputs[1].value) {
            return [inputs[0].value, inputs[1].value];
        }
        return null;
    }
    public set filterValueType(value: string) {
        this._filterValueType = value;
    }
    constructor() {
        super();
        this.templateId = "filter-input-range-template";
        this.filterValueType = this.attributeOption('filter-value-type', 'number') as string;
        this.render();
    }

    protected setupEventListeners(): void {
       const inputs = this.inputs;
       inputs.forEach(input => {
            input.addEventListener('input', (e: Event) => {
                if(this.value){
                    console.log(`FilterInputRangeComponent: input event, value: ${this.value}`);
                    const customInputEvent = new Event("change-input")
                    this.dispatchEvent(customInputEvent);
                }
            });
        });
    }
    protected render(): void {
        templateParseToElement(this.templateId, this, {
            filterValueType: this.filterValueType,
            inputId: this.createRandomId(),
        });

        this.setupEventListeners();
    }
}